import React, { useEffect } from 'react';
import ParentDocCard from '../../common/ParentDocCard';
import { useDispatch } from 'react-redux';
import { loadExternalApis } from '../../../features/external-api/redux/loadExternalApis';
import { REST_API } from 'drapcode-constant';
import { CustomDataMappingTable } from './CustomDataMappingTable';

export const CustomDataMappingTab = ({
  projectId,
  version,
  projectDetail,
  customDataMappings,
  environments,
  actions,
  flag,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadExternalApis({ projectId, version, externalApiType: REST_API }));
  }, [dispatch]);

  return (
    <>
      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
        <CustomDataMappingTable
          projectId={projectId}
          version={version}
          customDataMappings={customDataMappings}
          environments={environments}
          projectDetail={projectDetail}
          actions={actions}
          flag={flag}
        />
      </div>
      <ParentDocCard>
        <h5>
          <b>About Custom Data Mapping</b>
        </h5>
        <p>Custom Data Mapping</p>
        <br />
      </ParentDocCard>
    </>
  );
};
